import {
  PUBLIC_SERVICE_LINKS_REQUEST,
  PUBLIC_SERVICE_LINKS_FAILURE,
  FETCH_PUBLIC_SERVICE_LINKS_SUCCESS,
  SET_FEATURED_PUBLIC_SERVICE_LINKS,
  SET_NORMAL_PUBLIC_SERVICE_LINKS,
  CREATE_PUBLIC_SERVICE_LINKS_SUCCESS,
  DELETE_PUBLIC_SERVICE_LINKS_SUCCESS,
  UPDATE_PUBLIC_SERVICE_LINKS_SUCCESS,
  GET_PUBLIC_SERVICE_LINKS_SUCCESS,
} from "../action/types";

// Sort featured items first, preserving relative order within each group
const sortByFeatured = (list) =>
  [...list].sort((a, b) => {
    if (a.isFeatured && !b.isFeatured) return -1;
    if (!a.isFeatured && b.isFeatured) return 1;
    return 0;
  });

const initialState = {
  publicServiceLinks: [],
  total: 0,
  currentPublicServiceLink: null,
  loading: false,
  error: null,
};

const publicServiceLinksReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case PUBLIC_SERVICE_LINKS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_PUBLIC_SERVICE_LINKS_SUCCESS: {
      const data = Array.isArray(payload?.data)
        ? payload.data
        : Array.isArray(payload)
          ? payload
          : [];
      return {
        ...state,
        loading: false,
        publicServiceLinks: data,
        total: payload?.total ?? data.length,
      };
    }

    // Kept for backward compatibility with fetchPublicServiceLinksSequential
    case SET_FEATURED_PUBLIC_SERVICE_LINKS:
      return {
        ...state,
        loading: true,
        publicServiceLinks: sortByFeatured([
          ...payload,
          ...state.publicServiceLinks.filter((item) => !item.isFeatured),
        ]),
      };

    case SET_NORMAL_PUBLIC_SERVICE_LINKS: {
      const featured = state.publicServiceLinks.filter(
        (item) => item.isFeatured,
      );
      const combined = sortByFeatured([...featured, ...payload]);
      return {
        ...state,
        loading: false,
        publicServiceLinks: combined,
        total: combined.length,
      };
    }

    case GET_PUBLIC_SERVICE_LINKS_SUCCESS:
      return {
        ...state,
        loading: false,
        currentPublicServiceLink: payload,
        publicServiceLinks: state.publicServiceLinks.map((item) =>
          item.id === payload?.id ? payload : item,
        ),
      };

    case CREATE_PUBLIC_SERVICE_LINKS_SUCCESS: {
      const created = payload;
      const featured = state.publicServiceLinks.filter(
        (item) => item.isFeatured,
      );
      const normal = state.publicServiceLinks.filter(
        (item) => !item.isFeatured,
      );
      // Insert new item at the top of the non-featured group (after all featured items)
      const newList = [...featured, created, ...normal];
      return {
        ...state,
        loading: false,
        publicServiceLinks: newList,
        total: state.total + 1,
      };
    }

    case UPDATE_PUBLIC_SERVICE_LINKS_SUCCESS: {
      const updated = payload;
      const newList = sortByFeatured(
        state.publicServiceLinks.map((item) =>
          item.id === updated?.id ? updated : item,
        ),
      );
      return {
        ...state,
        loading: false,
        publicServiceLinks: newList,
      };
    }

    case DELETE_PUBLIC_SERVICE_LINKS_SUCCESS: {
      const deletedId = payload;
      return {
        ...state,
        loading: false,
        publicServiceLinks: state.publicServiceLinks.filter(
          (item) => item.id !== deletedId,
        ),
        total: Math.max(0, state.total - 1),
      };
    }

    case PUBLIC_SERVICE_LINKS_FAILURE:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return state;
  }
};

export default publicServiceLinksReducer;
